<mat-card>
  <mat-card-content>
    <form #f="ngForm" (ngSubmit)="onSubmit()">
      <h2>Register</h2>
      @if (warning()) {
      <div>
        <mat-error> Warning: {{warning()}}</mat-error><br />
      </div>
      }
      <mat-form-field class="full-width-input">
        <input class="form-control" matInput placeholder="User Name" name="userName" [(ngModel)]="registerUser.userName"
          required autofocus #userName="ngModel">
        <mat-error>Please provide a valid user name</mat-error>
      </mat-form-field><br />
      <mat-form-field class="full-width-input">
        <input class="form-control" matInput type="password" placeholder="Password" #password="ngModel"
          [(ngModel)]="registerUser.password" name="password" minlength="8" required>
        <mat-error>Please provide a valid password</mat-error>
      </mat-form-field><br />
      <mat-form-field class="full-width-input">
        <input class="form-control" matInput type="password" placeholder="Confirm Password" #password2="ngModel"
          [(ngModel)]="registerUser.password2" name="password2" minlength="8" required>
        <mat-error>Passwords must match and be at least 8 characters</mat-error>
      </mat-form-field><br />
      <button class="form-control" mat-raised-button color="primary" type="submit">
        <mat-icon>account_box</mat-icon>
        <span>&nbsp;&nbsp;&nbsp;Register</span>
      </button>
    </form>
  </mat-card-content>
  @if (successA()) {
  <div class="success">Registration Successful. Proceed to<br /><br />
    <a mat-raised-button color="accent" routerLink="/login">
      <mat-icon>login</mat-icon>&nbsp;&nbsp;&nbsp;Login
    </a>
  </div>
  }
</mat-card>